import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import BannerSlider from "../components/BannerSlider";
import CategorySlider from "../components/CategorySlider";
import ProductSlider from "../components/ProductSlider";
import {
  FaWallet,
  FaShareAlt,
  FaProductHunt,
  FaChartLine,
  FaGift,
  FaCar,
  FaCrown,
  FaUsers,
  FaStar,
  FaRocket,
  FaStore,
  FaTruck,
  FaAward,
  FaGem,
  FaExchangeAlt,
  FaMobile,
  FaDesktop,
  FaGlobe,
  FaTrophy,
  FaRupeeSign,
  FaPercent,
  FaCheckCircle,
  FaUserTie,
  FaBuilding,
  FaHeadset,
  FaShieldAlt,
  FaChartBar,
  FaTree,
  FaInfinity,
  FaHandHoldingUsd,
  FaCoins,
  FaUniversity,
  FaQrcode,
  FaArrowRight,
  FaPlayCircle,
  FaPhone,
  FaEnvelope,
  FaWhatsapp
} from "react-icons/fa";

// Color palette
const colors = {
  brightBlue: '#00A9EC',
  deepOrange: '#E06207',
  nearBlack: '#0E1306',
  green: '#018F2C',
  darkBrown: '#602005',
  burntOrange: '#A65007',
  lightOrange: '#EF9222',
  darkGreen: '#056619',
  reddishBrown: '#9C2E04',
  darkBlue: '#0067A1',
  skyBlue: '#0DC8F8',
  peachOrange: '#FDA653',
  navyBlue: '#023057',
  oliveBrown: '#604B0C',
  tealBlue: '#024D6E',
  pinkMagenta: '#A70756',
  goldenYellow: '#F3D71B',
  freshGreen: '#12B14A',
  lightGreen: '#55CB71',
  lightCyan: '#56E0F9'
};

function Home() {
  const [headerHeight, setHeaderHeight] = useState(80); // Default height

  useEffect(() => {
    // Get actual header height dynamically
        
    const updateHeaderHeight = () => {
      const header = document.querySelector('header');
      if (header) {
        setHeaderHeight(header.offsetHeight);
      }
    };

    // Update on mount and resize
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    // Also update on scroll (since header height changes when scrolled)
    window.addEventListener('scroll', updateHeaderHeight);

    return () => {
      window.removeEventListener('resize', updateHeaderHeight);
      window.removeEventListener('scroll', updateHeaderHeight);
    };
  }, []);

  return (
    <div className="bg-white">
      {/* Hero Section - Accounts for fixed header */}
      
      <section
        className="flex items-center justify-center text-white relative overflow-hidden"
        style={{
          background: `linear-gradient(135deg, ${colors.navyBlue} 0%, ${colors.darkBlue} 80%)`,
          paddingTop: `${headerHeight + 80}px`,
          paddingBottom: '80px',
          minHeight: '100vh'
        }}
      >
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-64 h-64 rounded-full bg-white"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 rounded-full bg-white"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            {/* Logo */}
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5 }}
              className="flex items-center justify-center gap-3 mb-6"
            >
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center text-white font-bold text-3xl shadow-lg"
                style={{ backgroundColor: colors.pinkMagenta,color:"blue" }}
              >
                A
              </div>
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center font-bold text-3xl shadow-lg"
                style={{ backgroundColor:colors.freshGreen ,color:"blue" }}
              >
                B
              </div>
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center text-white font-bold text-3xl shadow-lg"
                style={{ backgroundColor:colors.goldenYellow ,color:"blue" }}
              >
                M
              </div>
            </motion.div>


            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-5xl md:text-7xl font-bold mb-4"
            >
              ABM GROUP ONE
            </motion.h1>

            {/* Bilingual Slogan */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.15 }}
              className="mb-8"
            >
              <div className="text-2xl md:text-3xl font-semibold mb-2" style={{ color: colors.goldenYellow, textShadow: '0 2px 8px rgba(0,0,0,0.18)' }}>
                “हर रोज़ का प्रोडक्ट, हर दिन की कमाई — आज आपकी तरक्की, कल परिवार की सुरक्षा।”
              </div>
              <div className="text-lg md:text-xl font-medium text-white/90" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.12)' }}>
                “Everyday products, daily income — your progress today, your family’s security tomorrow.”
              </div>
            </motion.div>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-xl md:text-2xl mb-8"
              style={{ color: colors.lightOrange }}
            >
              Next-Generation Hybrid MLM Platform
            </motion.p>

            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="text-lg mb-10 max-w-2xl mx-auto text-white/80"
            >
              Join India's most transparent and rewarding MLM ecosystem with Matrix + Generation plan
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="flex flex-wrap gap-4 justify-center"
            >
              <Link
                to="/register"
                className="px-8 py-4 rounded-lg font-bold text-lg hover:shadow-2xl transition transform hover:-translate-y-1 flex items-center gap-2"
                style={{
                  background: `linear-gradient(135deg, ${colors.deepOrange}, ${colors.burntOrange})`,
                  color: 'white'
                }}
              >
                Get Started <FaArrowRight />
              </Link>
              <Link
                to="/about"
                className="px-8 py-4 bg-white/20 backdrop-blur-sm rounded-lg font-bold text-lg hover:bg-white/30 transition flex items-center gap-2"
              >
                <FaPlayCircle /> Watch Demo
              </Link>
            </motion.div>

            {/* Stats */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.8 }}
              className="grid grid-cols-3 gap-4 mt-16 max-w-2xl mx-auto"
            >
              <div className="text-center">
                <div className="text-3xl font-bold" style={{ color: colors.lightOrange }}>11+</div>
                <div className="text-sm text-white/70">Income Sources</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold" style={{ color: colors.lightOrange }}>50K+</div>
                <div className="text-sm text-white/70">Happy Members</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold" style={{ color: colors.lightOrange }}>₹100Cr+</div>
                <div className="text-sm text-white/70">Payouts Done</div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Product Slider Section */}
      {/* <ProductSlider /> */}

      {/* <BannerSlider />
      <CategorySlider /> */}

      {/* ===== FEATURED HIGHLIGHTS ===== */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-4 max-w-5xl mx-auto">
            {[
              { icon: FaShieldAlt, text: '100% Secure Platform', color: colors.darkBlue },
              { icon: FaPercent, text: '5% TDS Compliance', color: colors.freshGreen },
              { icon: FaMobile, text: '5-Login System', color: colors.deepOrange },
              { icon: FaWhatsapp, text: 'Instant Notification', color: colors.freshGreen },
            ].map((item, idx) => (
              <div key={idx} className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl">
                <item.icon className="text-2xl" style={{ color: item.color }} />
                <span className="font-medium text-sm">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== TWO PARTNERSHIP MODELS ===== */}
      <section className="py-20" style={{ backgroundColor: '#f8fafc' }}>
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4" style={{ color: colors.nearBlack }}>
              Choose Your Partnership Model
            </h2>
            <p className="text-xl" style={{ color: colors.oliveBrown }}>
              Two ways to grow with ABM Group
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">

            {/* Share Partner Card */}
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="h-3" style={{ background: `linear-gradient(90deg, ${colors.deepOrange}, ${colors.burntOrange})` }}></div>
              <div className="p-8">
                <div className="w-20 h-20 rounded-2xl flex items-center justify-center text-4xl text-white mb-6"
                  style={{ background: `linear-gradient(135deg, ${colors.deepOrange}, ${colors.burntOrange})` }}>
                  <FaShareAlt />
                </div>
                <h3 className="text-2xl font-bold mb-2" style={{ color: colors.darkBrown }}>Loan-Based Business Partnership</h3>
                <p className="text-sm mb-6" style={{ color: colors.oliveBrown }}>
                  Provide loans to companies and earn returns through multiple income channels.
                </p>

                <div className="space-y-4 mb-8">
                  {['Growth Capital Partner Income', 'Capital Connector Partner Income', 'Growth Incentive Partner Income'].map((item, idx) => (
                    <div key={idx} className="flex items-center gap-3">
                      <FaCheckCircle style={{ color: colors.deepOrange }} />
                      <span>{item}</span>
                    </div>
                  ))}
                </div>

                <Link
                  to="/register"
                  className="block w-full text-center py-3 rounded-lg font-semibold border-2 transition"
                  style={{
                    borderColor: colors.deepOrange,
                    color: colors.deepOrange
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = colors.deepOrange;
                    e.target.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = colors.deepOrange;
                  }}
                >
                  Know More
                </Link>
              </div>
            </motion.div>

            {/* Product Partner Card */}
            <motion.div
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl overflow-hidden shadow-xl"
            >
              <div className="h-3" style={{ background: `linear-gradient(90deg, ${colors.freshGreen}, ${colors.darkGreen})` }}></div>
              <div className="p-8">
                <div className="w-20 h-20 rounded-2xl flex items-center justify-center text-4xl text-white mb-6"
                  style={{ background: `linear-gradient(135deg, ${colors.freshGreen}, ${colors.darkGreen})` }}>
                  <FaProductHunt />
                </div>
                <h3 className="text-2xl font-bold mb-2" style={{ color: colors.darkGreen }}>Product User & Advisor Partnership</h3>
                <p className="text-sm mb-6" style={{ color: colors.oliveBrown }}>
                  Use products and earn commissions through multiple income streams
                </p>

                <div className="space-y-4 mb-8">
                  {["Retail Profit: 10% to 25%", 'Direct Bonus (5%)', 'Matrix Income (15%)', 'Generation Income (11%)', 'Rank Rewards', 'Car Bonus (4%)', 'Royalty (2%)'].slice(0, 4).map((item, idx) => (
                    <div key={idx} className="flex items-center gap-3">
                      <FaCheckCircle style={{ color: colors.freshGreen }} />
                      <span>{item}</span>
                    </div>
                  ))}
                  <div className="text-sm font-semibold" style={{ color: colors.freshGreen }}>
                    +2 More Benefits
                  </div>
                </div>

                <Link
                  to="/register"
                  className="block w-full text-center py-3 rounded-lg font-semibold border-2 transition"
                  style={{
                    borderColor: colors.freshGreen,
                    color: colors.freshGreen
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = colors.freshGreen;
                    e.target.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = colors.freshGreen;
                  }}
                >
                  Know More
                </Link>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ===== KEY FEATURES ===== */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4" style={{ color: colors.nearBlack }}>
              Platform Features
            </h2>
            <p className="text-xl" style={{ color: colors.oliveBrown }}>
              Everything you need to succeed
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">

            {[
              {
                icon: FaWallet,
                title: '3-Tier Wallet System',
                desc: 'LBBP, PU&AP & E-Wallet with seamless transfers',
                color: colors.deepOrange
              },
              {
                icon: FaChartLine,
                title: 'Matrix Plan (3× Infinity)',
                desc: '11 levels of matrix income with spillover benefits',
                color: colors.brightBlue
              },
              {
                icon: FaUsers,
                title: 'Generation Income',
                desc: '7 rank-based generation commissions',
                color: colors.pinkMagenta
              },
              {
                icon: FaTrophy,
                title: 'Rank Rewards',
                desc: 'Achieve ranks & get exciting rewards + tours',
                color: colors.goldenYellow
              },
              {
                icon: FaCar,
                title: 'Car Bonus Program',
                desc: 'Special car bonus for top performers',
                color: colors.deepOrange
              },
              {
                icon: FaGift,
                title: 'Royalty Program',
                desc: 'Monthly royalty on team performance',
                color: colors.freshGreen
              },
              {
                icon: FaStore,
                title: 'My Pickup Center',
                desc: '3% commission on orders as extra product',
                color: colors.darkBrown
              },
              {
                icon: FaTruck,
                title: 'Mobile Store',
                desc: '6% commission + delivery boy features',
                color: colors.freshGreen
              },
              {
                icon: FaShieldAlt,
                title: 'Secure & Compliant',
                desc: 'KYC, GST bills, 5% TDS, 7-day return policy',
                color: colors.darkBlue
              },
            ].map((feature, idx) => (
              <motion.div
                key={idx}
                whileHover={{ scale: 1.05 }}
                className="bg-slate-50 p-6 rounded-xl hover:shadow-lg transition"
              >
                <div className="w-14 h-14 rounded-lg flex items-center justify-center text-2xl text-white mb-4"
                  style={{ backgroundColor: feature.color }}>
                  <feature.icon />
                </div>
                <h3 className="text-lg font-bold mb-2">{feature.title}</h3>
                <p className="text-sm" style={{ color: colors.oliveBrown }}>{feature.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== INCOME HIGHLIGHTS ===== */}
      <section className="py-20" style={{ backgroundColor: '#f8fafc' }}>
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4" style={{ color: colors.nearBlack }}>
              Multiple Income Streams
            </h2>
            <p className="text-xl" style={{ color: colors.oliveBrown }}>
              Earn from 8 different sources
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">

            {[
              { name: 'Retail Profit', value: '10% to 25%', color: colors.teal || '#008080' },
              { name: 'Direct Bonus', value: '5%', color: colors.freshGreen },
              { name: 'Matrix Income', value: '15%', color: colors.brightBlue },
              { name: 'Generation Income', value: '11%', color: colors.pinkMagenta },
              { name: 'Active Member Reward', value: '5%', color: colors.coral || '#FF7F50' },
              { name: 'Reward Tour Bonus', value: '3%', color: colors.goldenYellow },
              { name: 'Car Bonus', value: '4%', color: colors.deepOrange },
              { name: 'Royalty Bonus', value: '2%', color: colors.purple || '#800080' },
            ].map((income, idx) => (
              <div key={idx} className="bg-white p-6 rounded-xl shadow-lg text-center">
                <div className="text-3xl font-bold mb-2" style={{ color: income.color }}>{income.value}</div>
                <div className="text-lg font-semibold">{income.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== RANK ACHIEVEMENTS PREVIEW ===== */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">

            {/* Left Content */}
            <div>
              <h2 className="text-4xl font-bold mb-4" style={{ color: colors.nearBlack }}>
                17 Achievement Ranks
              </h2>
              <p className="text-lg mb-6" style={{ color: colors.oliveBrown }}>
                Climb the ladder of success with our comprehensive rank system. Each rank comes with exciting rewards and recognition.
              </p>

              <div className="space-y-4">
                {[
                  'Starter to Legacy Founder',
                  'Monthly Rank Rewards',
                  'Tour Programs (Domestic & International)',
                  'Special Recognition & Gifts'
                ].map((item, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <FaCheckCircle style={{ color: colors.freshGreen }} />
                    <span>{item}</span>
                  </div>
                ))}
              </div>

              <Link
                to="/ranks"
                className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-lg font-semibold"
                style={{
                  backgroundColor: colors.deepOrange,
                  color: 'white'
                }}
              >
                View All Ranks <FaArrowRight />
              </Link>
            </div>

            {/* Right Content - Rank Preview */}
            <div className="grid grid-cols-3 gap-3">
              {[
                'Starter', 'Builder', 'Achiever',
                'Performer', 'Grower', 'Leader',
                'Star Leader', 'Silver', 'Gold'
              ].map((rank, idx) => (
                <div key={idx} className="p-4 bg-slate-50 rounded-lg text-center">
                  <FaCrown className="mx-auto mb-2" style={{ color: colors.goldenYellow }} />
                  <div className="text-xs font-bold">{rank}</div>
                </div>
              ))}
              <div className="col-span-3 text-center text-sm font-semibold mt-2" style={{ color: colors.deepOrange }}>
                +8 More Ranks
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIALS ===== */}
      <section className="py-20" style={{ backgroundColor: '#f8fafc' }}>
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4" style={{ color: colors.nearBlack }}>
              What Our Members Say
            </h2>
            <p className="text-xl" style={{ color: colors.oliveBrown }}>
              Join thousands of successful partners
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {[
              {
                name: "Rajesh Kumar",
                rank: "Gold Rank Achiever",
                testimonial: "Best MLM platform I've ever joined. Transparent system, timely payouts, and amazing support team.",
                stars: 5,
                gradient: "from-blue-400 to-purple-400"
              },
              {
                name: "Priya Sharma",
                rank: "Platinum Director",
                testimonial: "My team has grown to 500+ members in just 8 months. The compensation plan is the most generous in the industry!",
                stars: 5,
                gradient: "from-green-400 to-teal-400"
              },
              {
                name: "Amit Verma",
                rank: "Diamond Achiever",
                testimonial: "The training and mentorship programs are exceptional. I've not only built a business but also developed leadership skills.",
                stars: 5,
                gradient: "from-orange-400 to-pink-400"
              },
              {
                name: "Sunita Patel",
                rank: "Ruby Executive",
                testimonial: "Finally found a company that values its distributors. The car bonus program helped me get my dream SUV!",
                stars: 5,
                gradient: "from-red-400 to-yellow-400"
              },
              {
                name: "Vikram Singh",
                rank: "Emerald Crown",
                testimonial: "Started part-time, now this is my full-time career. The royalty income has given me financial freedom at 35.",
                stars: 5,
                gradient: "from-indigo-400 to-cyan-400"
              },
              {
                name: "Anjali Desai",
                rank: "Sapphire Ambassador",
                testimonial: "What sets this platform apart is the integrity. Every penny is accounted for and the support team is always available.",
                stars: 5,
                gradient: "from-purple-400 to-pink-400"
              }
            ].map((testimonial, idx) => (
              <div key={idx} className="bg-white p-6 rounded-xl shadow-lg">
                <div className="flex items-center gap-2 mb-4">
                  {[...Array(testimonial.stars)].map((_, i) => (
                    <FaStar key={i} style={{ color: colors.goldenYellow }} />
                  ))}
                </div>
                <p className="text-sm mb-4 italic" style={{ color: colors.oliveBrown }}>
                  "{testimonial.testimonial}"
                </p>
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-full bg-gradient-to-r ${testimonial.gradient}`}></div>
                  <div>
                    <p className="font-bold">{testimonial.name}</p>
                    {/* <p className="text-xs" style={{ color: colors.oliveBrown }}>{testimonial.rank}</p> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== CTA SECTION ===== */}
      <section className="py-20 relative overflow-hidden"
        style={{
          background: `linear-gradient(135deg, ${colors.navyBlue}, ${colors.darkBlue})`
        }}
      >
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 h-64 rounded-full bg-white"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-white"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Ready to Start Your Journey?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto" style={{ color: colors.lightOrange }}>
            Join ABM Group One today and unlock your earning potential
          </p>

          <div className="flex flex-wrap gap-4 justify-center">
            <Link
              to="/register"
              className="px-10 py-4 bg-white rounded-lg font-bold text-lg hover:shadow-2xl transition transform hover:-translate-y-1"
              style={{ color: colors.navyBlue }}
            >
              Create Free Account
            </Link>
            <Link
              to="/contact"
              className="px-10 py-4 border-2 border-white rounded-lg font-bold text-lg hover:bg-white/20 transition"
            >
              Contact Sales
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-12 text-sm">
            <span className="flex items-center gap-2">
              <FaPhone /> 8887355992
            </span>
            <span className="flex items-center gap-2">
              <FaEnvelope /> support.abmgroupone@gmail.com
            </span>
            <span className="flex items-center gap-2">
              <FaWhatsapp /> 24/7 Support
            </span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;